import request from '@/utils/request'

// 查询列表
export function apiGetGrossRequirementList (query) {
  return request({
    url: '/mes/mesGrossRequirement/grossRequirementList',
    method: 'get',
    params: query
  })
}

// 生成版本弹窗提示-上一版本下拉框
export function apiGetSelectLastVersion () {
  return request({
    url: '/mes/mesGrossRequirement/selectLastVersion',
    method: 'get'
  })
}

// 生成版本弹窗提示-最新版本
export function apiGetSelectNextVersion () {
  return request({
    url: '/mes/mesGrossRequirement/selectNextVersion',
    method: 'get'
  })
}

// 生成版本
export function apiPostBuildVersion (data) {
  return request({
    url: '/mes/mesGrossRequirement/buildVersion',
    method: 'post',
    data: data
  })
}

// 潘通色号下拉列表
export function apiGetPantoneSelectList (params) {
  return request({
    url: '/mes/mesGrossRequirement/selectPantone',
    method: 'get',
    params
  })
}

// 导出列表
export function apiMesGrossRequirementNewExport (data) {
  return request({
    url: '/mes/mesGrossRequirement/v2/grossRequirementExport',
    method: 'post',
    data: data
  })
}

// 版本号下拉列表
export function apiGetVersionSelectList (params) {
  return request({
    url: '/mes/mesGrossRequirement/selectVersion',
    method: 'get',
    params
  })
}
